import { TranslationChunksConfig } from '@spartacus/core';
import { de } from './base/de';
import { en } from './base/en';
import { es_MX } from './base/es_MX';
import { fr_CA } from './base/fr_CA';
import { ja } from './base/ja';
interface TranslationResources {
  [lang: string]: {
    [chunkName: string]: {
      [key: string]: any;
    };
  };
}

export const translationsOverwrite: TranslationResources = {
  en,
  es_MX,
  fr_CA,
  ja,
  de
};

export const customTranslationChunksConfig: TranslationChunksConfig = {
  common: [
    'searchBox',
    'customLoginPage',
    'common',
    'pageMetaResolver',
    'Common',
    'formErrors',
    'httpHandlers',
    'user',
    'registrationDemoLandingPage',
    'registrationDemoForm',
    "WarrentyParagraph",
    "coreReport",
    "warrentyLandingPageParagraph",
    "SelectAllVehicalPopup",
    "waiver_popup_content",
    "dataExtractionRquest",
    "dataExtractionOverviewPage",
    "bendix_data_extraction_disclaimer_popup",
    "customerVehicleOwnerForm",
    "requestorForm",
    "reportECURecipientForm",
    "vehicleInformation",
    "IncidentForm",
    "returnShippingInformation",
    "ECUForm",
    "DTC_PAGE",
    "orderConfirmation",
    "navigation",
  ]
};
